import React, { useState, useEffect } from 'react';
import {config} from "../shared/config.js";
import * as util from '../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError.jsx';
import Laoding from '../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintContraxtBill from '../prints/PrintContraxtBill.jsx';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../shared/GeneralDialogFooter.jsx';


export default function ShowMyBuyServices(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [buyServices, setBuyServices] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [buyService, setBuyService] = useState(null);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
            userId:"",
            serviceId:"",
            includeDone:true,
            includeNotDone:true,
            fromDate:0,
            toDate:0,
            searchText:"",
            lastIndex:0,
            pageSize:0
        };
        var url = config.Server+`/contract/services/to-client/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                setBuyServices(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const showBuyService = function(c, cInd){
        return(
            <Row style={{margin:"10px 0px 0px 0px"}}>
                <Col md={12} style={{border:"1px solid #b0b0b0", boxSizing:"border-box", padding:"10px", borderRadius:"10px", position:"relative", backgroundColor:(cInd%2==1)?"#efefef":"#FFF"}}>
                    <Row style={{borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right", fontWeight:"bold"}}>شماره خدمت: {util.toPersianDigits(c.buyNo)}</Col>
                        <Col md="8" style={{textAlign:"right"}}>نوع خدمت: {c.service.title}</Col>
                    </Row>
                    <Row style={{borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right", fontWeight:"bold"}}>زمان درخواست: {util.toPersianDigits(util.SeperateDate(c.buyDate)+"-" + util.SeperateTime(c.buyTime))}</Col>
                        <Col md="8" style={{textAlign:"right"}}>شرح: {c.comment}</Col>
                    </Row>
                    <Row style={{borderBottom:"1px dashed #b0b0b0", paddingBottom:"10px"}}>
                        <Col md="4" style={{textAlign:"right", fontWeight:"bold"}}>
                            وضعیت: 
                            {
                                c.isDone?
                                <span style={{backgroundColor:"#1ea01eff", color:"#FFF", padding:"5px 10px", borderRadius:"5px"}}>انجام شده</span>
                                :
                                <span style={{backgroundColor:"#ff0000", color:"#FFF", padding:"5px 10px", borderRadius:"5px"}}>در حال انجام</span>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست خدمات..." />
                </Col>
            </Row>
        </>
        :(buyServices.length == 0)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <table>
                        <tbody>
                            <tr><td style={{textAlign:"center"}}>تا کنون هیچ درخواست خدمتی نکرده اید</td></tr>
                            <tr><td style={{textAlign:"center", paddingTop:"20px"}}><Button severity="success" onClick={()=>{navigate('/buy-service')}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;خرید اولین خدمت&nbsp;&nbsp;</Button></td></tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست خدمات من
            </div>
            <Row style={{padding:"0px", margin:"0px 0px 0px 0px", position:"relative"}}>
                {
                    buyServices.map((c, cInd)=>{
                        return(
                            <>{showBuyService(c, cInd)}</>
                        )
                    })
                }
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}